export default "__VITE_ASSET__c57709f8__"